/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumeration of available search filter options
 * @export
 */
export const SearchFilterEnum = {
    All: 'All',
    Name: 'Name',
    Email: 'Email',
    Phone: 'Phone',
    Address: 'Address',
    CompanyName: 'CompanyName'
} as const;
export type SearchFilterEnum = typeof SearchFilterEnum[keyof typeof SearchFilterEnum];


export function instanceOfSearchFilterEnum(value: any): boolean {
    for (const key in SearchFilterEnum) {
        if (Object.prototype.hasOwnProperty.call(SearchFilterEnum, key)) {
            if (SearchFilterEnum[key as keyof typeof SearchFilterEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchFilterEnumFromJSON(json: any): SearchFilterEnum {
    return SearchFilterEnumFromJSONTyped(json, false);
}

export function SearchFilterEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFilterEnum {
    return json as SearchFilterEnum;
}

export function SearchFilterEnumToJSON(value?: SearchFilterEnum | null): any {
    return value as any;
}

export function SearchFilterEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SearchFilterEnum {
    return value as SearchFilterEnum;
}

